<template>
    <component :is="view" />
</template>

<script>
    export default {
        name: 'CustomRouterView',
        props: {
            routeConfig: {
                type: Object,
                required: true,
            },
        },
        computed: {
            view() {
                return this.routeConfig[this.$route.name];
            },
        },
    };
</script>
